import { render, staticRenderFns } from "./droplist_customer.vue?vue&type=template&id=06721d18"
import script from "./droplist_customer.vue?vue&type=script&lang=js"
export * from "./droplist_customer.vue?vue&type=script&lang=js"
import style0 from "./droplist_customer.vue?vue&type=style&index=0&id=06721d18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports